import { VenueType } from '../../../../App.types'
import { Trainer } from '../../ActivityDetails.types'

import MultipleTrainers from './MultipleTrainers'
import SingleTrainer from './SingleTrainer'

interface Props {
  trainers: Array<Trainer>
  venueType: VenueType | null
}

const Trainers = ({ trainers, venueType }: Props) => {
  if (!trainers.length) return null

  if (trainers.length === 1) {
    return <SingleTrainer trainer={trainers[0]} venueType={venueType} />
  }

  return <MultipleTrainers trainers={trainers} venueType={venueType} />
}

export default Trainers
